"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Exported CSM Provider class which implements the general metrics providers.
 * It has configure, recordEvent and getName methods implemented.
 * @implements IMetricsProviders
 */
var CSMProvider = /** @class */ (function () {
    /**
     * Creates an instance by setting the provider name which is optional.
     * It also calls the configure method by default.
     *
     * @param name [string=DEFAULT_METRICS_NAME] - the name of the provider.
     */
    function CSMProvider(name) {
        if (name === void 0) { name = constants_1.DEFAULT_METRICS_NAME; }
        this.providerName = name;
        this.configure();
    }
    /**
     * Configure the provider for the client specific variables.
     *
     * @param config {object} - configuration object to configure the CSM provider
     * most of the variables should be auto filled by the csm library embedded in the html
     *
     */
    CSMProvider.prototype.configure = function (config) {
        if (config === void 0) { config = {}; }
        // @ts-ignore
        Object.keys(config).forEach(function (key) { return window[key] = config[key]; });
        window.ue_url = window.ue_url || '/uedata/uedata';
        window.ue_sn = window.ue_sn || 'www.amazon.com';
        window.ue_furl = window.ue_furl || 'fls-na.amazon.com';
    };
    /**
     * Records an event into the CSM.ue.t list of events.
     * Read [Event Types](https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Formulas) to know
     * about different events
     *
     * @param event {Object} - This is the event to be recorded
  
     * @return boolean - Denotes whether the event was recorded or not
     */
    CSMProvider.prototype.recordEvent = function (event) {
        var eventData = event.getEventData();
        var eventName = eventData.eventType;
        var scope = eventData.name;
        var counters = eventData.counters;
        if (window.ue) {
            if (window.ue.count && typeof window.ue.count == 'function') {
                //loop through all the counters key value pair to record counters
                for (var counterName in counters) {
                    // we can read more [here](https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Instrumentation/ClientSideCounters#Front-end_API)
                    // about api documentation of ue.count
                    window.ue.count(counterName, counters[counterName], {
                        scope: scope
                    });
                }
            }
            window.uet(eventName, scope);
            window.uex('ld', scope);
            return true;
        }
        return false;
    };
    /**
     * Returns the name of the metrics provider
     *
     * @return string - name of the metrics provider
     */
    CSMProvider.prototype.getName = function () {
        return this.providerName;
    };
    return CSMProvider;
}());
exports.default = CSMProvider;
//# sourceMappingURL=csm-provider.js.map